import React from 'react';
import {changeToSlug} from '@helper/string.helper';
import LoadingDetailLink from './LoadingDetailLink';

export default function LinkMedicalFacilityDetail({medicalFacility = {}, children}) {
    const nameSlug = changeToSlug(medicalFacility.business_name);
    const slug = nameSlug && medicalFacility.business_id ? `${nameSlug}-m${medicalFacility.business_id}` : '';

    return <LoadingDetailLink href={slug ? `/${slug}` : ''}>{children}</LoadingDetailLink>;
}
